// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SchedulesModel } from "@eisinc/App/Handlers/saveScheduledLines";
import { get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

const schedulesUrl = "api/custom/cart/schedules";
export interface SchedulesLinesApiResult {}

export interface SchedulesLinesApiResult {
    cartId: string;
    hasScheduledDeliveries: boolean;
    groups: CartGroup[];
    canCustomerScheduleOrders: boolean;
}

export interface CartGroup {
    cartLine: CartLineModel;
    scheduledQty: number;
    items: ScheduledItem[];
    messages: string[];
}

export interface ScheduledItem {
    qty: number;
    requestedDeliveryDate: string | null;
    requestedDeliveryDateDisplay?: string;
}

export async function getScheduledLinesApi(parameter: any): Promise<ServiceResult<SchedulesLinesApiResult>> {
    try {
        const getScheduledLinesModel = await get<SchedulesLinesApiResult>(schedulesUrl, parameter);
        return {
            result: getScheduledLinesModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.message,
        };
    }
}

export function saveScheduledLinesApi(parameter: SchedulesModel) {
    return post<SchedulesModel>(schedulesUrl, parameter);
}
